module.exports = __webpack_public_path__ + "static/media/programme.d7e77c32.jpg";